// 核心数据 Mixins

export const coreMixins = {
  data() {
    return {
      animal: [],
      nutrition: [],
      raw: [],
      loading: false,
      pagination: {},
      typeList: [],
    }
  },
  methods: {

    // 动物类型
    async getAnimal(arg = {}) {
      const params = { parentId: 0, ...arg }
      const res = await this.$get('/nhf-core-data/animal/listByParentId', params)
      return res.data
    },

    // 动物详情
    async getAnimalDetail(arg = {}) {
      const params = { ...arg }
      const res = await this.$getForm('/nhf-core-data/animal/typeInfoDetail', params)
      this.animalDetail = res.data
      return res.data
    },

    // 原料
    async getCoreRawList(arg = {}) {
      const params = { current: 1, size: 10, ...arg }
      try {
        this.loading = true
        const res = await this.$get('/nhf-core-data/raw/rawUserPage', params)
        this.raw = res.data
        this.setPager(res.data)
        return res.data
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      } finally {
        this.loading = false
      }
    },

    //  营养指标
    async getCoreNutrition(arg = {}) {
      const params = { current: 1, size: 10, ...arg }
      try {
        this.loading = true
        const res = await this.$get('/nhf-core-data/nutritiontarget/nutritionUserPage', params)
        this.nutrition = res.data
        this.setPager(res.data)
        return res.data
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      } finally {
        this.loading = false
      }
    },

    // 原料、营养指标、类型
    // @params parentId 父级Id
    // @params category  原料：raw 营养指标： nutritiontarget,

    async getTypeList(params, set) {
      try {
        // 获取片区id
        let obj = window.localStorage.getItem('factoryDetail')
        let factoryDetail = obj ? JSON.parse(obj) : {}
        let { deptId } = factoryDetail
        // const res = await this.$get('/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeId', params)
        const res = await this.$get('/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit', { ...params, deptId })
        if (!set) this.typeList = res.data.map(this.mapFilter)
        return res.data.map(this.mapFilter)
      } catch (error) {
        error.msg && this.$message.error(error.msg)
      }
    },

    setPager(res) {
      const { total, current, size: pageSize } = res
      this.pagination = { ...this.pagination, pageSize, total, current }
    },

    mapFilter(i) {
      return {
        ...i,
        label: i.name,
        value: i.id,
        isLeaf: !i.hasChildren
      }
    },

    cleanSelect() {
      this.selectedRowKeys = []
      this.selectedRows = []
    },
  }
}